module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiExt.50f2b26.eot";